import { SpaceSelectCompass } from "@circle-react-shared/SpaceSelectCompass";
import { Portal } from "@circle-react-uikit/Portal";
import { SpaceTrigger } from "@circle-react/components/QuickPostV3/Composer/SpaceTrigger";
import {
  QUICK_POST_V3_MOBILE_SPACE_SELECT_PORTAL_ID,
  SPACE_SELECT_DROPDOWN_MAX_HEIGHT,
  SPACE_SELECT_DROPDOWN_MAX_WIDTH,
} from "@circle-react/components/QuickPostV3/constants";
import { useComposerLayout } from "@circle-react/components/QuickPostV3/hooks/useComposerLayout";
import { useSpacesContext } from "@circle-react/contexts/spacesContext";
import { classNames } from "@circle-react/helpers/twMergeWithCN";

export const FooterSpaceSelect = () => {
  const { isMdScreen } = useComposerLayout();
  const {
    helpers: { basicSpacesWithPostCreationAllowed },
  } = useSpacesContext();
  const spaces = basicSpacesWithPostCreationAllowed();

  return (
    <div className="min-w-0">
      <Portal
        selectorQuery={`#${QUICK_POST_V3_MOBILE_SPACE_SELECT_PORTAL_ID}`}
        disablePortal={isMdScreen}
      >
        <div
          className={classNames("min-w-0", {
            "border-primary border-t": !isMdScreen,
          })}
        >
          <SpaceSelectCompass
            spaces={spaces}
            name="space_id"
            trigger={<SpaceTrigger isMd={isMdScreen} />}
            dropdownMaxWidth={SPACE_SELECT_DROPDOWN_MAX_WIDTH}
            dropdownMaxHeight={SPACE_SELECT_DROPDOWN_MAX_HEIGHT}
          />
        </div>
      </Portal>
    </div>
  );
};
